class LazyLoadedVideo {
    constructor($element) {
        this.$ELEMENT = $element instanceof jQuery ? $element : $($element);
        this.observer = null;

        if (this.$ELEMENT.length <= 0) {
            return;
        }

        this.registerHooks();
    }

    registerHooks() {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };
        this.observer = new IntersectionObserver(this.handleIntersection, observerOptions);
        this.observer.observe(this.$ELEMENT[0]);
    }

    handleIntersection = (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                this.loadVideo();
                this.observer.unobserve(entry.target);
                this.cleanupObserver();
            }
        });
    };

    loadVideo() {
        const src = this.$ELEMENT.attr('data-src');
        this.$ELEMENT.attr('src', src);
        this.$ELEMENT[0].load();
        if (this.$ELEMENT.attr('autoplay')) {
            this.$ELEMENT[0].play();
            this.$ELEMENT.attr('muted', true);
        }
        this.$ELEMENT.removeClass('js-lazyloaded-video');
    };

    cleanupObserver() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }
}


(function () {
    $('.js-lazy-loaded-video').each(function (i, videoElement) {
        new LazyLoadedVideo($(videoElement));
    });
})();
